module.exports = __webpack_public_path__ + "static/media/9DESA3.61c96e52.jpg";